import MessageActionsDropdownButton from './MessageActionsDropdownButton';
import MessageActionsButton from './MessageActionsButton';
import styled from 'styled-components';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMessageActionButton = styled(MessageActionsButton).withConfig({
  displayName: "ActionButtonComponent__StyledMessageActionButton",
  componentId: "sc-1vc03ec-0"
})(["margin-left:4px;"]);
const ActionButtonComponent = ({
  children,
  onClick,
  collapsed,
  i18nButtonText,
  buttonIcon,
  tooltipProps,
  disabled,
  'data-test-id': dataTestId
}) => {
  if (collapsed) {
    return /*#__PURE__*/_jsxs(MessageActionsDropdownButton, {
      onClick: onClick,
      buttonIcon: buttonIcon,
      "data-test-id": dataTestId,
      tooltipProps: tooltipProps,
      disabled: disabled,
      children: [i18nButtonText, children]
    });
  } else {
    return /*#__PURE__*/_jsx(StyledMessageActionButton, {
      onClick: onClick,
      buttonIcon: buttonIcon,
      "data-test-id": dataTestId,
      disabled: disabled,
      tooltipProps: Object.assign({}, tooltipProps, {
        title: i18nButtonText
      })
    });
  }
};
ActionButtonComponent.displayName = 'ActionButtonComponent';
export default ActionButtonComponent;